/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { metricsGet } from "../funcs/metricsGet.js";
import { metricsLimits } from "../funcs/metricsLimits.js";
import { ClientSDK } from "../lib/sdks.js";
import { unwrapAsync } from "../types/fp.js";
export class Metrics extends ClientSDK {
    /**
     * Get Metrics
     *
     * @remarks
     * Get metrics about your orders and subscriptions.
     *
     * Currency values are output in cents.
     *
     * **Scopes**: `metrics:read`
     */
    async get(request, options) {
        return unwrapAsync(metricsGet(this, request, options));
    }
    /**
     * Get Metrics Limits
     *
     * @remarks
     * Get the interval limits for the metrics endpoint.
     *
     * **Scopes**: `metrics:read`
     */
    async limits(options) {
        return unwrapAsync(metricsLimits(this, options));
    }
}
//# sourceMappingURL=metrics.js.map